import { Alert, Box, Typography, CssBaseline, ThemeProvider } from '@mui/material';

import themev5 from '../../themev5';
import useSnapshotComparisonList from './hooks/useSnapshotComparisonList';
import SnapshotComparisonFilters from './components/SnapshotComparisonFilters';
import SnapshotComparisonTable from './components/SnapshotComparisonTable';
import pageStyles from './styles';

const SnapshotComparison = () => {
  const {
    rows,
    total,
    loading,
    error,
    page,
    pageSize,
    filters,
    setQcStatus,
    setChangeDetectionStatus,
    setApplicationNumber,
    clearFilters,
    changePage,
    changePageSize
  } = useSnapshotComparisonList();

  return (
    <ThemeProvider theme={themev5}>
      <CssBaseline />
      <Box sx={pageStyles.page}>
        <Typography variant='h5' gutterBottom>
          Snapshot Comparison
        </Typography>

        <SnapshotComparisonFilters
          filters={filters}
          onQcStatusChange={setQcStatus}
          onChangeDetectionStatusChange={setChangeDetectionStatus}
          onApplicationNumberSearch={setApplicationNumber}
          onClear={clearFilters}
        />

        {error && (
          <Box mt={2}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        )}

        <SnapshotComparisonTable
          rows={rows}
          total={total}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={changePage}
          onPageSizeChange={changePageSize}
        />
      </Box>
    </ThemeProvider>
  );
};

export default SnapshotComparison;
